"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractCreateVariantCommand = void 0;
const AbstractVariantCommand_1 = require("../AbstractVariantCommand");
class AbstractCreateVariantCommand extends AbstractVariantCommand_1.AbstractVariantCommand {
    constructor(api, appId, type) {
        super(api, appId);
        this.def = {};
        this.withName = (name) => {
            this.def.name = name;
            return this;
        };
        this.withDeveloper = (developer) => {
            this.def.developer = developer;
            return this;
        };
        this.withSecret = (secret) => {
            this.def.secret = secret;
            return this;
        };
        this.withDescription = (description) => {
            this.def.description = description;
            return this;
        };
        this.withDefinition = (def) => {
            this.def = {
                ...this.def,
                ...def,
            };
            return this;
        };
        this.exec = async () => {
            return (await this.api.post(`/applications/${this.appId}/${this.type}`, this.def)).data;
        };
        this.type = type;
    }
}
exports.AbstractCreateVariantCommand = AbstractCreateVariantCommand;
//# sourceMappingURL=AbstractCreateVariantCommand.js.map